import { useTranslation } from 'react-i18next'

import { REQUEST_DOC_FLOWS_ENTITY } from '../../../../constants/entity'
import { SUBMENU_DEFAULT_VALUE } from '../../../../constants/route'
import { getEmptyPermanentFilters } from '../../../../utils/filter'
import Button from '../../../Button'
import { FILTER_BAR_FILTER_TRIGGER_VARIANT, FilterBar } from '../../../Filter'
import { TableModalSearch } from '../../../TableModal'
import {
  REQUEST_PROFILE_TAB_DOC_FLOWS_BUTTON_TEXT_KEY,
  REQUEST_PROFILE_TAB_DOC_FLOWS_FILTER_BAR_ITEMS_PROPS,
  REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME,
  REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_HEIGHT,
  REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_MAX_LENGTH,
} from '../RequestProfileTabDocFlows.constants'

import * as styles from './RequestProfileTabDocFlowsToolbar.module.css'

import LinkIcon from '../../../../icons/link-1.svg'
import PlusIcon from '../../../../icons/plus.svg'

function RequestProfileTabDocFlowsToolbar({
  availableFilters,
  canCreateDocFlow,
  filterValues,
  isSkeleton,
  ordering,
  pagination,
  requestId,
  search,
  setFilterValues,
  onChangeSearch,
  onClearSearch,
  onClickConnect,
  onClickCreate,
  onReload,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.toolbar}>
      <TableModalSearch
        height={REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_HEIGHT}
        isSkeleton={isSkeleton}
        maxLength={REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_MAX_LENGTH}
        placeholder='Common.SearchPlaceholderKey'
        qaName={REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME.search}
        showError={false}
        skeletonClassName={styles.searchSkeleton}
        value={search}
        wrapperClassName={styles.search}
        onChange={onChangeSearch}
        onClear={onClearSearch}
      />
      <FilterBar
        responsive
        availableFilters={availableFilters}
        className={styles.filterBar}
        entity={REQUEST_DOC_FLOWS_ENTITY}
        filterBarItemsProps={
          REQUEST_PROFILE_TAB_DOC_FLOWS_FILTER_BAR_ITEMS_PROPS
        }
        filterTriggerVariant={FILTER_BAR_FILTER_TRIGGER_VARIANT.COMPACT_ICON}
        filterValues={filterValues}
        getPermanentFilters={getEmptyPermanentFilters}
        isSkeleton={isSkeleton}
        objectId={requestId}
        ordering={ordering}
        pagination={{ per_page: pagination?.pageSize }}
        setFilterValues={setFilterValues}
        sub={SUBMENU_DEFAULT_VALUE}
        onReload={onReload}
      />
      <div className={styles.actions}>
        {canCreateDocFlow ? (
          <Button.Text
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.actionButton}
            isSkeleton={isSkeleton}
            qaName={REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME.create}
            text={t(REQUEST_PROFILE_TAB_DOC_FLOWS_BUTTON_TEXT_KEY.create)}
            textClassName={styles.buttonText}
            onClick={onClickCreate}
          />
        ) : null}
        <Button.Text
          beforeIconProps={{ Icon: LinkIcon }}
          className={styles.actionButton}
          isSkeleton={isSkeleton}
          qaName={REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME.connect}
          text={t(REQUEST_PROFILE_TAB_DOC_FLOWS_BUTTON_TEXT_KEY.connect)}
          textClassName={styles.buttonText}
          onClick={onClickConnect}
        />
      </div>
    </div>
  )
}

export default RequestProfileTabDocFlowsToolbar
